import PropTypes from "prop-types";
import GenericModal from "./generic-modal.component";

export default function TermsConditions({
  action,
  accept,
  state,
}) {
  return (
    <GenericModal
      onClick={(event) => {
        if (event.target.classList.contains("close-modal")) {
          action();
        }
      }}
      modalState={state}
    >
      <div className="bg-white p-[54px] justify-center items-center text-center max-h-[70lvh] overflow-auto">
        <button
          onClick={() => action()}
          className="close-modal py-[5px] px-3 rounded-full border border-black absolute top-3 right-3"
        >
          X
        </button>
        <div className="flex flex-col gap-5 justify-center items-center ">
           <h3 className="font-bold">Terms and Conditions</h3>
           <p className="">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Obcaecati sapiente dolorem sed eaque veniam fugit, ipsam, facilis perferendis vitae, earum labore adipisci aperiam alias a illo possimus! Ratione quod enim consectetur cumque quibusdam! Commodi sunt ad quasi? Natus, voluptatem quos, vitae amet doloribus fuga aut in, ullam iste voluptates quasi quia at quas voluptate. Possimus unde quia totam sed eum.
           </p>
           <p className="">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Obcaecati sapiente dolorem sed eaque veniam fugit, ipsam, facilis perferendis vitae, earum labore adipisci aperiam alias a illo possimus! Ratione quod enim consectetur cumque quibusdam! Commodi sunt ad quasi? Natus, voluptatem quos, vitae amet doloribus fuga aut in, ullam iste voluptates quasi quia at quas voluptate. Possimus unde quia totam sed eum.
           </p>
           <p className="">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Obcaecati sapiente dolorem sed eaque veniam fugit, ipsam, facilis perferendis vitae, earum labore adipisci aperiam alias a illo possimus! Ratione quod enim consectetur cumque quibusdam! Commodi sunt ad quasi? Natus, voluptatem quos, vitae amet doloribus fuga aut in, ullam iste voluptates quasi quia at quas voluptate. Possimus unde quia totam sed eum.
           </p>
           <p className="">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Obcaecati sapiente dolorem sed eaque veniam fugit, ipsam, facilis perferendis vitae, earum labore adipisci aperiam alias a illo possimus! Ratione quod enim consectetur cumque quibusdam! Commodi sunt ad quasi? Natus, voluptatem quos, vitae amet doloribus fuga aut in, ullam iste voluptates quasi quia at quas voluptate. Possimus unde quia totam sed eum.
           </p>
           <p className="">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Obcaecati sapiente dolorem sed eaque veniam fugit, ipsam, facilis perferendis vitae, earum labore adipisci aperiam alias a illo possimus! Ratione quod enim consectetur cumque quibusdam! Commodi sunt ad quasi? Natus, voluptatem quos, vitae amet doloribus fuga aut in, ullam iste voluptates quasi quia at quas voluptate. Possimus unde quia totam sed eum.
           </p>
           <p className="">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Obcaecati sapiente dolorem sed eaque veniam fugit, ipsam, facilis perferendis vitae, earum labore adipisci aperiam alias a illo possimus! Ratione quod enim consectetur cumque quibusdam! Commodi sunt ad quasi? Natus, voluptatem quos, vitae amet doloribus fuga aut in, ullam iste voluptates quasi quia at quas voluptate. Possimus unde quia totam sed eum.
           </p>
           <p className="">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Obcaecati sapiente dolorem sed eaque veniam fugit, ipsam, facilis perferendis vitae, earum labore adipisci aperiam alias a illo possimus! Ratione quod enim consectetur cumque quibusdam! Commodi sunt ad quasi? Natus, voluptatem quos, vitae amet doloribus fuga aut in, ullam iste voluptates quasi quia at quas voluptate. Possimus unde quia totam sed eum.
           </p>
           <p className="">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Obcaecati sapiente dolorem sed eaque veniam fugit, ipsam, facilis perferendis vitae, earum labore adipisci aperiam alias a illo possimus! Ratione quod enim consectetur cumque quibusdam! Commodi sunt ad quasi? Natus, voluptatem quos, vitae amet doloribus fuga aut in, ullam iste voluptates quasi quia at quas voluptate. Possimus unde quia totam sed eum.
           </p>
           <p className="">Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempore temporibus autem, reprehenderit numquam deleniti officiis molestiae quod architecto incidunt aperiam nemo corporis at veniam doloremque. Repudiandae ratione odio explicabo atque.</p>
        <button className="w-full rounded-md text-white p-3 bg-primary hover:bg-blue-900 font-semibold cursor-pointer" onClick={accept}> Accept </button>
        </div>

      </div>
    </GenericModal>
  );
}


TermsConditions.propTypes = {
  action: PropTypes.func.isRequired,
  accept: PropTypes.func.isRequired,
  state: PropTypes.bool.isRequired,
};
